// extracted by mini-css-extract-plugin
export default {"wrapper":"SummaryWrapper_wrapper__7BFJJ"};